import * as z from "zod";

export const getSegmentProducts = {
  name: "getSegmentProducts" as const,
  input: z.null(),
  output: z.array(
    z.object({ id: z.string(), handle: z.string(), title: z.string() }),
  ),
};
